import script from "./TrustAccounting.vue?vue&type=script&setup=true&lang=js"
export * from "./TrustAccounting.vue?vue&type=script&setup=true&lang=js"

import "./TrustAccounting.vue?vue&type=style&index=0&id=3d18eaa2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d18eaa2"]])

export default __exports__